import e from "./SourceTabs.module.js";
import { c as t } from "react/compiler-runtime";
import n from "classnames";
import r from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/SourceTabs/SourceTabs.tsx
var o = r.memo((r) => {
	let o = t(22), s, c, l, u, d;
	if (o[0] !== r) {
		let { options: e, selected: t, onSelectTab: n, hint: i, ...a } = r;
		l = e, u = t, s = i, c = a, d = (e) => {
			n(e.currentTarget.getAttribute("data-id") ?? "");
		}, o[0] = r, o[1] = s, o[2] = c, o[3] = l, o[4] = u, o[5] = d;
	} else s = o[1], c = o[2], l = o[3], u = o[4], d = o[5];
	let f = d, p;
	o[6] === s ? p = o[7] : (p = s && /* @__PURE__ */ i("div", {
		className: e.hint,
		children: s
	}), o[6] = s, o[7] = p);
	let m;
	if (o[8] !== f || o[9] !== l || o[10] !== u) {
		let t;
		o[12] !== f || o[13] !== u ? (t = (t) => /* @__PURE__ */ i("li", {
			className: n(e.option),
			title: t.tooltip,
			children: /* @__PURE__ */ i("button", {
				"data-id": t.id,
				className: n(e.button, { [e.selected]: u === t.id }),
				onClick: f,
				children: /* @__PURE__ */ i("span", {
					className: e.content,
					tabIndex: -1,
					children: t.title
				})
			}, t.id)
		}, t.id), o[12] = f, o[13] = u, o[14] = t) : t = o[14], m = l.map(t), o[8] = f, o[9] = l, o[10] = u, o[11] = m;
	} else m = o[11];
	let h;
	o[15] !== c || o[16] !== m ? (h = /* @__PURE__ */ i("ul", {
		className: e.list,
		...c,
		children: m
	}), o[15] = c, o[16] = m, o[17] = h) : h = o[17];
	let g;
	o[18] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ i("div", { className: e.tail }), o[18] = g) : g = o[18];
	let _;
	return o[19] !== p || o[20] !== h ? (_ = /* @__PURE__ */ a("div", {
		className: e.container,
		children: [
			p,
			h,
			g
		]
	}), o[19] = p, o[20] = h, o[21] = _) : _ = o[21], _;
});
//#endregion
export { o as SourceTabs };
